// Hideo - a choice kept per profile in localStorage as { <profile id>: <id> } (the active project, creatorOS_project;
// the open saved plan, creatorOS_pedview). Read again at every call, like the legacy code did; `ver` is bumped at every
// change so that computeds reading get() run again. Called inside a store's setup (one `ver` per store).
// The keys and the JSON format never change (stored data, CLAUDE.md rule 3).
import { ref, type Ref } from 'vue'
import { parseActiveMap } from '../features/projects'

export interface PerProfileChoice {
  /** The choice of that profile (undefined = none); reactive through `ver` */
  get(profile: string): string | undefined
  /** Stores the choice of that profile */
  set(profile: string, id: string): void
  ver: Ref<number>
}

export function perProfileChoice(key: string): PerProfileChoice {
  const ver = ref(0)
  const read = (): Record<string, string> => {
    try { return parseActiveMap(localStorage.getItem(key)) } catch { return {} }
  }
  return {
    ver,
    get(profile) { void ver.value; return read()[profile] },
    set(profile, id) {
      const m = read()
      m[profile] = id
      try { localStorage.setItem(key, JSON.stringify(m)) } catch { /* storage full or blocked */ }
      ver.value++
    }
  }
}
